/* eslint-disable react/display-name */
import {
  Button,
  IconButton,
  Tooltip,
  Grid,
  CircularProgress,
  Typography,
} from "@mui/material";

import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import { SyncUtils } from "../../../utils/SyncUtils";
import InventoryAdjustmentSingleItem from "./InventoryAdjustmentSingleItem";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function InventoryAdjustmentList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [data, setData] = useState([]);
  const [rowLimitPerPage, setRowLimitPerPage] = useState(
    Math.round((getWindowDimensions().height - 155) / 32)
  );
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    //loadByRest();
    let filter = [];

    loadByRest(0, rowLimitPerPage, "[]", JSON.stringify(filter));
  }
  async function loadByRest(curPage, pageSize, sort, filter) {
    setIsLoading(true);

    let cacheMode = true;
    let result = {};
    let excludeList = [];

    if (cacheMode) {
      result = SyncUtils.listSerchInCache(
        props.productCache,
        excludeList,
        JSON.parse(filter), //FILTER
        JSON.parse(sort), //SORT
        JSON.parse(
          //LIMIT
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        )
      );
    } else {
      result = await API.get(
        "/api/v1/products?range=" +
          encodeURIComponent(
            "[" + curPage * pageSize + "," + (curPage + 1) * pageSize + "]"
          ) +
          "&filter=" +
          encodeURIComponent(filter) +
          "&sort=" +
          encodeURIComponent(sort)
      );
    }
    var arr = result.data.contentRange.split("/");
    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    setOption(opt);
    setData(result.data.data);

    //var arr = result.data.contentRange.split("/");
    //const opt = { ...option };
    //opt.count = parseInt(arr[2]);
    //etOption(opt);
    //setData(result.data);
    setIsLoading(false);
  }

  var biRef = {};

  function onEditClicked(row) {
    biRef.singleItemAdjustment.showInventoryAdjustmentSingleItem(
      row.tableData[row.rowIndex].id
    );
  }

  async function onTableChange(tableState) {
    console.log(tableState);
    let sort = [{ id: "name", sortOrder: "ASC" }];
    let search = [];
    if (tableState.sortOrder.name) {
      sort = [];
      sort.push({
        id: tableState.sortOrder.name,
        sortOrder: tableState.sortOrder.direction === "desc" ? "DESC" : "ASC",
      });
    }

    if (tableState.searchText) {
      search.push({
        id: "code",
        value: tableState.searchText,
        regExp: ".*" + tableState.searchText + ".*",
        matchType: "BROAD_MATCH",
        operatorType: "",
        conditionType: "or",
        fieldValueType: "string",
      });
      search.push({
        id: "name",
        value: tableState.searchText,
        conditionType: "or",
        regExp: ".*" + tableState.searchText.toUpperCase() + ".*",
        matchType: "BROAD_MATCH",
        operatorType: "",
        fieldValueType: "string",
      });
      search.push({
        id: "barcode",
        value: tableState.searchText,
        conditionType: "or",
        regExp: ".*" + tableState.searchText + ".*",
        matchType: "BROAD_MATCH",
        operatorType: "",
        fieldValueType: "string",
      });
    }
    loadByRest(
      tableState.page,
      rowLimitPerPage,
      JSON.stringify(sort),
      JSON.stringify(search)
    );
  }

  const options = {
    serverSide: true,
    //filterType: "dropdown",
    filter: false,
    download: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: getWindowDimensions().height - 155,
    rowsPerPage: Math.round((getWindowDimensions().height - 155) / 32),
    rowsPerPageOptions: [
      Math.round((getWindowDimensions().height - 155) / 32),
      10,
      15,
      50,
      100,
    ],
    print: false,
    customToolbar: () => {
      return <React.Fragment></React.Fragment>;
    },
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want

      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        default:
        //console.log("action not handled." + action);
      }
    },
  };

  const [option, setOption] = useState(options);

  const columns = [
    {
      name: "code",
      label: translate("Code"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "name",
      label: translate("Name"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "category1Name",
      label: translate("Department"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) =>
          tableMeta.tableData[tableMeta.rowIndex].deptName,
      },
    },
    {
      name: "action",
      label: translate("Actions"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({ align: "right" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <Button
            onClick={() => onEditClicked(tableMeta, updateValue, value)}
            color="secondary"
            style={{
              margin: 0,
              padding: 0,
              height: 17,
              width: 27,
              alignText: "right",
            }}
          >
            {translate("Edit")}
          </Button>
        ),
      },
    },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <div>
          <MUIDataTable
            title={
              <Typography variant="h6">
                {translate("Inventory Adjustment List")}
                {isLoading && (
                  <CircularProgress
                    size={24}
                    style={{ marginLeft: 15, position: "relative", top: 4 }}
                  />
                )}
              </Typography>
            }
            data={data}
            columns={columns}
            options={option}
          />
        </div>
      </Grid>
      <InventoryAdjustmentSingleItem
        biRef={biRef}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
      ></InventoryAdjustmentSingleItem>
    </Grid>
  );
}
